var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgHomeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 9.15l-9-7.7c-.7-.6-1.9-.6-2.6 0l-9 7.7c-.4.4-.7.9-.7 1.5v10.3c0 1.1.9 2 2 2h5v-7c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v7h5c1.1 0 2-.9 2-2v-10.3c0-.6-.3-1.1-.7-1.5z"
  })));
}

export default SvgHomeFilled;